export default __webpack_public_path__ + "7cd76786922077ee43c8076cfd12c00a.svg";